export default __webpack_public_path__ + "static/media/404.068a1758.png";